import config from "config";

export const GOVERNMENT_FIELDS = `
id
name
aliases
inCountry {
  id
  name
  region {
    id
    name
  }
}
description
employeeRange
founded
lat
linkedIn
lng
logo
website
city
status
createdAt
lastUpdatedBy @include(if: $isAdmin)
updatedAt
verticalProfiles(where:{vertical: ${config.VERTICAL}}) {
  id
  vertical
  keySources
  partnerships(where: {vertical: ${config.VERTICAL}}) @include(if: $isAuth) {
    id
    date
    description
    source
    updatedAt
    createdAt
    status
    vertical
    verticalProfiles {
      id
      entity {
        id
        name
        logo
        vertical
      }
      entityTypeProfiles {
        entityType
      }
    }
  }
  entityTypeProfiles(where: {
    OR: [
      { entityType: GOVERNMENT_AGENCY },
      { entityType: NATIONAL_LAB },
    ]
  }) {
    id
    entityType
    status
    interestInVertical
    raised @include(if: $isAuth)
  }
}
`;
